<template>
    <div
        class="h-full bg-cover bg-local lg:bg-fixed bg-center relative"
        :style="{ backgroundImage: `url('${this.background}')` }"
    >
        <div
            v-if="dimValue > 0"
            class="absolute inset-0 z-10"
            :style="{ opacity: dimValue, backgroundColor: '#061f3e' }"
        ></div>
        <div class="relative z-20">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Parallax',

    props: {
        background: {
            type: String,
            required: true,
        },
        dim: {
            type: Number,
            default: 0.5,
        },
    },
    computed: {
        dimValue: function () {
            if (this.dim != null) {
                return this.dim;
            }

            return 0.5;
        },
    },
};
</script>
